<template>

  <span>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-tabs :value="active_step" :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none"
                 id="profile-tabs" :key="isSmallerScreen">
          <vs-tab icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'Sundry Items' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <sundry-item-list/>
            </div>
          </vs-tab>
          <vs-tab v-if="$canAny(['view-sundry-orders', 'create-edit-sundry-orders'])" icon-pack="feather" icon="icon-archive" :label="!isSmallerScreen ? 'Sundry Item Orders' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <sundry-item-orders-list/>
            </div>
          </vs-tab>
          <vs-tab v-if="$canAny(['view-sundry-items-use-report'])" icon-pack="feather" icon="icon-pie-chart" :label="!isSmallerScreen ? 'Predicted Use Report' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <report-table/>
            </div>
          </vs-tab>
          <vs-tab v-if="$canAny(['view-sundry-items-use-report'])" icon-pack="feather" icon="icon-bar-chart" :label="!isSmallerScreen ? 'Low Stock Report' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <LowStockReportTable/>
            </div>
          </vs-tab>
          <vs-tab v-if="$canAny(['view-sundry-items-use-report'])" icon-pack="feather" icon="icon-bar-chart" :label="!isSmallerScreen ? 'Slow Stock Report' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <SlowStockReportTable/>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
  </span>
</template>

<script>

  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  const CustomerRepository = RepositoryFactory.get('customer');
  import SundryItemList from "../supplier-manage/sundry-suppliers/sundry-supplier-tabs/SundryItemList";
  import SundryItemOrdersList from "./item-orders/SundryItemOrdersList";
  import ReportTable from './predicted-use-report/ReportTable.vue'
  import LowStockReportTable from './low-stock-report/ReportTable.vue'
  import SlowStockReportTable from '@/views/pages/sundry-items/slow-stock-report/ReportTable.vue'

  export default {
    name: 'SundryItemsTabView',
    components: {
      SundryItemList,
      SundryItemOrdersList,
      LowStockReportTable,
      ReportTable,
      SlowStockReportTable
    },
    data() {
      return {
        active_step: this.$route.query.step ? this.$route.query.step : '0'
      }
    },
    computed: {
      isSmallerScreen() {
        return this.$store.state.windowWidth < 768
      }
    },
    methods: {}
  }
</script>

<style lang="scss">
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
  }
</style>
